// extracted by mini-css-extract-plugin
export default {"spacingAddress":"ConfirmAddress_spacingAddress__nwbSK"};